import { JtechAxios } from 'src/plugins/axios'

export const LoginRepository = {
  login: async function (authenticationRequest) {
    const authResp = await JtechAxios.request().post(
      'authentication/authenticate',
      authenticationRequest
    )
    return authResp.data
  },
  refreshToken: async function () {
    const authResp = await JtechAxios.request().post(
      'authentication/refreshToken'
    )
    return authResp.data
  },
  password: async function (passwordRequest) {
    const authResp = await JtechAxios.request().post(
      'users/self/password',
      passwordRequest
    )
    return authResp.data
  },
  googleAuth: async (googleAuthRequest) => {
    const googleAuthResp = await JtechAxios.request().post(
      'sso/google',
      googleAuthRequest
    )
    return googleAuthResp.data
  }
}
